import { create } from "zustand";

import axios from "../helper/axios";

const useTeamTimeSheetStore = create((set) => ({
    dailyAttendance: null,
    monthlyAttendance: null,
    yearlyAttendance: null,
    attendanceUpdateFlag:false,
    monthlyAttendanceUpdateFlag:false,
    yearlyAttendanceUpdateFlag:false,
    approveUserList:[],
    approveUserListFlag:false,
    teamLeavesApplicationList:[],
    leavesConfigList:null,
    updateLeaveConfigListFlag: false,
    monthlyAttendanceAggregate:null,
    yearlyAttendanceAggregate:null,
    refreshTeamList:false,

    assignApprovar: async (body) => {
        try {
            console.log(body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/setAssignApprovar/${userData.qhoid}/${userData.qhuid}`,
                body
            ); 
            console.log("setAssignApprovar", response.data)
            set({ refreshTeamList: true }); 
            
        } catch (err) {
            console.error(err);
        }
    },     
    approveTeamTimesheet: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/docheckincheckout/${userData.qhoid}/${userData.qhuid}/${userData.username}`,
                body
            );
            set({ attendanceUpdateFlag: true });  
        } catch (err) {
            console.error(err);
        }
    }, 
    getTeamsMonthlyAttendance: async (body) => {
        try {
            console.log("getTeamsMonthlyAttendance", body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/getTeamsMonthlyAttendance/${userData.qhoid}/${userData.qhuid}/${userData.username}`,body
            );
            console.log("getTeamsMonthlyAttendance", response.data)
            set({ monthlyAttendance: response.data.data });                       
        } catch (err) {
            console.error(err);
        }
    },
    getTeamsMonthlyAttendanceAggregate: async (body) => {
        try {
            console.log("getTeamsMonthlyAttendanceAggregate", body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/getTeamsMonthlyAttendanceAggregate/${userData.qhoid}/${userData.qhuid}/${userData.username}`,body
            );
            console.log("getTeamsMonthlyAttendanceAggregate", response.data)
            set({ monthlyAttendanceAggregate: response.data.data });                       
        } catch (err) {
            console.error(err);
        }
    },    
    getTeamsYearlyAttendance: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log("getTeamsYearlyAttendance", body)
            const response = await axios.post(
                `/getTeamsYearlyAttendance/${userData.qhoid}/${userData.qhuid}/${userData.username}`,body
            );
            console.log("getTeamsYearlyAttendance", response.data)
            set({ yearlyAttendance: response.data.data });                        
        } catch (err) {
            console.error(err);
        }
    },
    getTeamsYearlyAttendanceAggregate: async (body) => {
        try {
            console.log("getTeamsYearlyAttendanceAggregate", body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/getTeamsYearlyAttendanceAggregate/${userData.qhoid}/${userData.qhuid}/${userData.username}`,body
            );
            console.log("getTeamsYearlyAttendanceAggregate", response.data)
            set({ yearlyAttendanceAggregate: response.data.data });                       
        } catch (err) {
            console.error(err);
        }
    },     
    getTeamTimeSheetAproveUsersList: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getTeamTimeSheetAproveUsersList/${userData.qhoid}/${userData.qhuid}/${userData.username}`
            );
            console.log("getTeamTimeSheetAproveUsersList", response.data)
            set({ approveUserList: response.data.adata }); 
            set({ approveUserListFlag: true });    
                                
        } catch (err) {
            console.error(err);
        }
    }, 
    getTeamLeavesApplicationsList: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getTeamsLeaveApplications/${userData.qhoid}/${userData.qhuid}`
            );
            console.log("getTeamsLeaveApplications", response.data)
            set({ teamLeavesApplicationList: response.data.data });  
                                
        } catch (err) {
            console.error(err);
        }
    },
    updateLeaveApplicationStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/updateLeaveApplicationStatus/${userData.qhoid}/${userData.qhuid}`,
                body
            );
             console.log("updateLeaveApplicationStatus", response.data) 
        } catch (err) {
            console.error(err);
        }
    }, 

    deleteLeaveConfigReq: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/deleteLeaveConfigReq/${userData.qhoid}/${userData.qhuid}`,
                body
            );
            set({updateLeaveConfigListFlag:true });
            console.log("deleteLeaveConfigReq", response.data) 
        } catch (err) {
            console.error(err);
        }
    },    
    leaveConfigSettingReq: async (body) => {
        try {
            console.log(body);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/leaveConfigSettingReq/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            set({updateLeaveConfigListFlag:true });

            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },  
    getLeavesConfigList: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getLeavesConfigList/${userData.qhoid}/${userData.qhuid}`
            );
            console.log("getLeavesConfigList", response.data)
            set({ leavesConfigList: response.data.data });  
                                
        } catch (err) {
            console.error(err);
        }
    },               
    resetFlags: () => {
        set({ attendanceUpdateFlag: false });
    }, 
    resetAprroveUsersListFlag: () => {
        set({ approveUserListFlag: false });
    },  
    resetLeaveConfigListFlag: () => {
        set({ updateLeaveConfigListFlag: false });
    },
    resetRefreshTeam: () => {
        set({ refreshTeamList: false });
    }, 
    
}));

export default useTeamTimeSheetStore;
